<template>
  <div>
    <div
      v-for="translation in nameTranslations"
      :key="translation.id"
    >
      <div v-if="translation.language.defaultLanguage">
        <div class="d-flex">
          <div class="d-flex align-items-center mr-2">
            <VtFlags
              v-if="translation.language.locale === 'en'"
              code="gb"
            />
            <VtFlags
              v-else
              :code="translation.language.locale"
            />
          </div>
          <vt-input
            v-model="translation.value"
            v-validate
            qa="configuration-name-translation-default-language-input"
            class="form-control-sm"
          />
        </div>
        <div><hr class="my-2"></div>
      </div>
      <div
        v-else
        class="translations-area"
      >
        <div class="d-flex">
          <div class="d-flex align-items-center mr-2">
            <VtFlags
              v-if="translation.language.locale === 'en'"
              code="gb"
            />
            <VtFlags
              v-else
              :code="translation.language.locale"
            />
          </div>
          <vt-input
            v-model="translation.value"
            v-validate
            qa="configuration-name-translation-language-input"
            class="form-control-sm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VtFlags from '@/components/common/VtFlags'

export default {
    name: 'ConfigurationNameTranslations',
    components: { VtFlags },
    inject: ['externalValidator'],
    props: {
        nameTranslations: { type: Array }
    },
    created() {
        this.$validator = this.externalValidator
    }
}
</script>

<style scoped>

</style>
